var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountedForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.8,14.4v5.2c0,.4.3.7.7.7h2.4c.9,0,1.5.7,1.5,1.5v10.2c0,.9-.7,1.5-1.5,1.5h-1.2c-.3-.3,0-.7,0-1.1,0-2.4-2.3-4.4-4.7-4.2-2.4.3-4.3,2.6-3.9,5,0,.3,0,.4-.3.4h-4.7c-.3,0-.4,0-.4-.4,0-1.5-.8-2.7-2.2-3.2s-2.6-.3-3.8.5c-.8.7-1.2,1.6-1.2,2.6s0,.4-.4.4h-1.5c-.4,0-.5,0-.4-.5.5-2.3,1.1-4.6,1.6-6.7,1.5-5.8,3-11.4,4.3-17.2.3-1.3,1.6-2.2,3.2-2.2h10.2c1.2,0,2,.8,2.2,2v5.5h0ZM29.6,20.5c.8-.3,1.6-.3,2.3-.3s.4,0,.4-.4v-10.4c0-.9,0-1.1-.9-1.1h-10.1c-.8,0-1.3.4-1.6,1.1-1.1,4.4-2.3,9-3.5,13.5,0,.3,0,.4.3.4h5.4c.4,0,.5,0,.5-.5-.1-1.9,1.1-2.8,2.6-2.7h0c.2,0,.3,0,.3-.3v-1.9c0-.4-.1-.5-.5-.4-.8,0-1.7.3-2.6.4-.5,0-.9-.3-.9-.7s.3-.9.8-.9c.9-.1,1.7-.3,2.7-.4.4,0,.8,0,1.1-.5,0-.1.3-.3.4-.4.7-.4,1.5-.5,2.3,0,.7.4,1.1.9.9,1.7v3.9h.3-.2,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.6,34.8h-3.2c-.7,0-1.2-.4-1.2-1.1s.4-1.1,1.2-1.1h4.8c.3,0,.4,0,.5-.4,2.4-9,4.7-18.2,7.1-27.2.3-.9.7-1.3,1.3-1.1.7,0,.8.8.7,1.6-2.4,9.6-5,19.1-7.4,28.5,0,.4-.3.7-.8.5h-3.1v.3h.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.8,32.6c0,1.9-1.5,3.4-3.4,3.4s-3.5-1.6-3.4-3.5c0-1.9,1.6-3.4,3.5-3.4s3.4,1.5,3.4,3.5h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.8,33.4c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.6,12.3c0,.8-.7,1.6-1.5,1.6s-1.6-.7-1.6-1.5.7-1.6,1.5-1.6,1.6.7,1.6,1.5h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountedForklift);
export default __webpack_public_path__ + "static/media/mounted-forklift.7de03d34d5ee8b879a60b0d3c416974a.svg";
export { ForwardRef as ReactComponent };